<mat-expansion-panel [style.margin-top.px]="20">
  <mat-expansion-panel-header>
    <mat-panel-title>
      Statistik
    </mat-panel-title>
    <mat-panel-description>
      Totalt beviljade lån:
      &nbsp;<strong>{{ adminService.statistics().total | number:'1.0-0':'sv' }}</strong>&nbsp; tkr
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div *matExpansionPanelContent>
    <mat-tab-group [style.max-height.vh]="50">
      @for (tab of tabArray; track tab) {
        <mat-tab [label]="tab.title">
          <ng-template matTabContent>
            <spb-table [data]="adminService.statistics()[tab.data]" [range]="tab.range"/>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
</mat-expansion-panel>
